import { faker } from '@faker-js/faker'

import { AdminApprovalProcessListItem, ApprovalProcessStatus, TargetLanguage } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getAdminApprovalProcessListItem = asBuilder((): AdminApprovalProcessListItem => {
  return {
    approvalProcessId: faker.number.int(),
    targetLanguage: faker.helpers.enumValue(TargetLanguage),
    hospital: {
      id: faker.number.int(),
      name: faker.string.uuid(),
      temporaryUnavailable: faker.datatype.boolean(),
    },
    serviceOfferId: faker.number.int(),
    requestedAtUtc: '2023-07-02T15:00:00.000',
    processStatusChangedAtUtc: '2023-07-09T15:00:00.000',
    approver: {
      id: faker.number.int(),
      nickname: faker.internet.userName(),
      reasons: faker.lorem.sentence(),
    },
    status: faker.helpers.enumValue(ApprovalProcessStatus),
  }
})
